import React from 'react';
import SEO from '../components/molecules/SEO'
import Container from '../components/atoms/Container';
import styled from 'styled-components';
import { graphql } from 'gatsby';
import RichTextConverter from '../components/atoms/RichTextConverter';

const Holder = styled.div`
  background-color: ${props => props.theme.colours.grey};
  padding: 4rem 0;
  h1 { text-align: center; }
  h2, h3, h4, h5, h6 { ${props => props.theme.fluidType( 0 )}; }
  ol {
      padding-left: 2rem;
      list-style-type: lower-latin;
  }
`;

const Inner = styled.div`
  max-width: 50rem;
  margin: 0 auto;
`;

const PrivacyPolicy = ( { data } ) => (
  <>
    <SEO title="Privacy Policy"/>
    <Holder>
      <Container>
        <Inner>
          <h1>Privacy Policy</h1>
          <RichTextConverter content={data.contentfulGlobalSettings.privacyPolicy}/>
        </Inner>
      </Container>
    </Holder>
  </>
);

export default PrivacyPolicy;

export const privacyQuery = graphql`
    query {
        contentfulGlobalSettings {
            privacyPolicy {
                raw
            }
        }
    }
`;

